import { render, staticRenderFns } from "./PaytrailPaymentMethods.vue?vue&type=template&id=650e58c9&scoped=true&"
import script from "./PaytrailPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PaytrailPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PaytrailPaymentMethods.vue?vue&type=style&index=0&id=650e58c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e58c9",
  null
  
)

export default component.exports